import { useEffect, useState } from "react";
import { formatDateTime } from "../domain/format";
import { fr } from "../i18n/fr";
import { Logo } from "../ui/components";

interface AppManifest {
  file: string;
  version: string;
  date: string;
  sizeBytes: number;
  sha256: string;
}

/** APK download page (SW §10.3). The manifest is written at deployment. Link to the privacy policy served by the server (DR21). */
export function AppPage() {
  const [m, setM] = useState<AppManifest | null | undefined>(undefined);
  useEffect(() => {
    fetch("/app/files/manifest.json").then((r) => (r.ok ? r.json() : null)).then(setM).catch(() => setM(null));
  }, []);
  return (
    <div className="page narrow">
      <div className="public-brand"><Logo size={40} /><h1>{fr.appPage.title}</h1></div>
      {m === null && <p>{fr.appPage.none}</p>}
      {m && (
        <>
          <table className="kv">
            <tbody>
              <tr><td>{fr.appPage.version}</td><td>{m.version}</td></tr>
              <tr><td>{fr.appPage.date}</td><td>{formatDateTime(m.date)}</td></tr>
              <tr><td>{fr.appPage.size}</td><td>{(m.sizeBytes / 1_048_576).toFixed(0)} Mo</td></tr>
              <tr><td>{fr.appPage.sha}</td><td className="mono small">{m.sha256}</td></tr>
            </tbody>
          </table>
          <p><a className="button primary" href={`/app/files/${m.file}`}>{fr.appPage.download}</a></p>
        </>
      )}
      <ul className="small">{fr.appPage.install.map((t) => <li key={t}>{t}</li>)}</ul>
      <p className="small"><a href="/confidentialite">{fr.appPage.privacy}</a></p>
    </div>
  );
}
